import script from "./certDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./certDialog.vue?vue&type=script&setup=true&lang=ts"

import "./certDialog.vue?vue&type=style&index=0&id=628283e3&lang=scss&scoped=true"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.2.2_@vue+compiler-sfc@3.4.27_vue@3.2.36_webpack@5.88.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-628283e3"]])

export default __exports__